import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Eyedropper"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 20.25H3.75V22.5H1.5V20.25ZM22.2825 5.46748L18.5325 1.71748C18.24 1.42669 17.7676 1.42669 17.475 1.71748L15 4.19248L14.0325 3.21748L12.9675 4.28248L13.9425 5.24998L6.21755 12.9675C6.07716 13.109 5.99889 13.3006 6.00005 13.5V14.6925L3.96755 16.7175C3.67675 17.01 3.67675 17.4825 3.96755 17.775L6.21755 20.025C6.51007 20.3158 6.98252 20.3158 7.27505 20.025L9.30755 18H10.5C10.6994 18.0011 10.891 17.9229 11.0325 17.7825L18.75 10.0575L19.7175 11.0325L20.7825 9.96748L19.8075 8.99998L22.2825 6.53248C22.5733 6.23996 22.5733 5.76751 22.2825 5.47498V5.46748ZM10.1925 16.5H8.69246L6.74996 18.4425L5.55746 17.25L7.49996 15.3075V13.8075L15 6.30749L17.6925 8.99999L10.1925 16.5ZM18.75 7.94249L16.0575 5.24999L18 3.30749L20.6925 5.99999L18.75 7.94249Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Eyedropper.vue"]]);
